module.exports = __webpack_public_path__ + "static/BG (Mobile)-ab6ed5438bfe3301ffcd68d440c475c3.png";